module.exports = __webpack_public_path__ + "static/media/onboarding-2.d928424e.svg";